import { render, staticRenderFns } from "./ModalTermsOfUse.vue?vue&type=template&id=55aebec2&lang=pug"
import script from "./ModalTermsOfUse.vue?vue&type=script&lang=js"
export * from "./ModalTermsOfUse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports